import {
  PatientPharmaciesResponse,
  PatientPharmacyAddRequest,
  PatientPharmacySyncRequest,
} from "@/types/dosespot";

import { requestData } from "@/api/api-config";

/**
 * Read a patient's pharmacies: the live DoseSpot list plus any form-reported
 * pharmacies not yet synced to DoseSpot.
 */
export async function getPatientPharmacies(
  patientId: string,
): Promise<PatientPharmaciesResponse | null> {
  return await requestData<PatientPharmaciesResponse>(
    `dosespot/patients/${patientId}/pharmacies`,
    "get",
    undefined,
    false,
  );
}

/**
 * Push a single form-reported pharmacy answer into DoseSpot. Syncs the patient
 * first if they aren't in DoseSpot yet. Returns the refreshed pharmacy lists.
 */
export async function syncPatientReportedPharmacy(
  patientId: string,
  request: PatientPharmacySyncRequest,
): Promise<PatientPharmaciesResponse | null> {
  return await requestData<PatientPharmaciesResponse>(
    `dosespot/patients/${patientId}/pharmacies/sync`,
    "post",
    { json: request },
    false,
  );
}

/**
 * Add a pharmacy staff picked from search to the patient's DoseSpot record. Syncs the
 * patient first if they aren't in DoseSpot yet. Returns the refreshed pharmacy lists.
 */
export async function addPatientPharmacy(
  patientId: string,
  request: PatientPharmacyAddRequest,
): Promise<PatientPharmaciesResponse | null> {
  return await requestData<PatientPharmaciesResponse>(
    `dosespot/patients/${patientId}/pharmacies`,
    "post",
    { json: request },
    false,
  );
}

/**
 * Remove a pharmacy from the patient's DoseSpot record. A pharmacy the patient reported
 * on a form stays on the chart as a reported entry. Returns the refreshed pharmacy lists.
 */
export async function removePatientPharmacy(
  patientId: string,
  pharmacyId: number,
): Promise<PatientPharmaciesResponse | null> {
  return await requestData<PatientPharmaciesResponse>(
    `dosespot/patients/${patientId}/pharmacies/${pharmacyId}`,
    "delete",
    undefined,
    false,
  );
}
